var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightCircleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C20.6274 2 26 7.37258 26 14C26 20.6274 20.6274 26 14 26C7.37258 26 2 20.6274 2 14C2 7.37258 7.37258 2 14 2ZM14 4C8.47715 4 4 8.47715 4 14C4 19.5228 8.47715 24 14 24C19.5228 24 24 19.5228 24 14C24 8.47715 19.5228 4 14 4ZM12.0429 9.29289C12.4334 8.90237 13.0666 8.90237 13.4571 9.29289L17.4571 13.2929C17.8476 13.6834 17.8476 14.3166 17.4571 14.7071L13.4571 18.7071C13.0666 19.0976 12.4334 19.0976 12.0429 18.7071C11.6524 18.3166 11.6524 17.6834 12.0429 17.2929L15.3358 14L12.0429 10.7071C11.6524 10.3166 11.6524 9.68342 12.0429 9.29289Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightCircleOutline);
export default __webpack_public_path__ + "static/media/chevron_right_circle_outline.2532f53f57ebf271597149f28e248106.svg";
export { ForwardRef as ReactComponent };